// import React from 'react';
// import './CitySection.css';
// import hyderabadImg from '../../assets/hyd.png';
// import vizagImg from '../../assets/vis.png';
// import vijayawadaImg from '../../assets/vij.png';

// const cities = [
//   { name: 'Hyderabad', image: hyderabadImg },
//   { name: 'Visakhapatnam', image: vizagImg },
//   { name: 'Vijayawada', image: vijayawadaImg },
// ];

// const CitySection = () => {
//   return (
//     <section className="city-section">
//       <h2>Your Perfect Place, Just a Click Away</h2>
//       <div className="city-grid">
//         {cities.map((city, idx) => (
//           <div className="city-card" key={idx}>
//             <img src={city.image} alt={city.name} />
//             <div className="city-name">{city.name}</div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default CitySection;

// import React from 'react';
// import { Box, Typography, useMediaQuery } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import hyderabadImg from '../../../assets/hyd.png';
// import vizagImg from '../../../assets/vis.png';
// import vijayawadaImg from '../../../assets/vij.png';

// const cities = [
//   { name: 'Hyderabad', image: hyderabadImg },
//   { name: 'Visakhapatnam', image: vizagImg },
//   { name: 'Vijayawada', image: vijayawadaImg },
// ];

// const CitySection = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   return (
//     <Box
//       component="section"
//       sx={{
//         py: '40px',
//         px: '20px',
//         textAlign: 'center',
//         bgcolor: '#ffffff',
//         fontFamily: 'Outfit',
//       }}
//     >
//       <Typography
//         variant="h5"
//         sx={{
//           fontSize: '1.9rem',
//           mb: '30px',
//           fontWeight: 500,
//         }}
//       >
//         Your Perfect Place, Just a Click Away
//       </Typography>

//       <Box
//         className="city-grid"
//         sx={{
//           display: 'flex',
//           flexWrap: 'wrap',
//           gap: '20px',
//           justifyContent: 'center',
//           flexDirection: isMobile ? 'column' : 'row',
//           alignItems: isMobile ? 'center' : 'stretch',
//         }}
//       >
//         {cities.map((city, idx) => (
//           <Box
//             key={idx}
//             className="city-card"
//             sx={{
//               width: isMobile ? '90%' : '480px',
//               height: '280px',
//               borderRadius: '12px',
//               overflow: 'hidden',
//               position: 'relative',
//               boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
//               transition: 'transform 0.3s ease',
//               '&:hover': {
//                 transform: 'translateY(-5px)',
//               },
//             }}
//           >
//             <Box
//               component="img"
//               src={city.image}
//               alt={city.name}
//               sx={{
//                 width: '100%',
//                 height: '280px',
//                 objectFit: 'cover',
//                 display: 'block',
//               }}
//             />
//             <Box
//               className="city-name"
//               sx={{
//                 backgroundColor: 'rgba(0, 0, 0, 0.6)',
//                 color: '#fff',
//                 fontSize: '1rem',
//                 position: 'absolute',
//                 bottom: 0,
//                 width: '100%',
//                 py: '30px',
//                 textAlign: 'center',
//                 fontFamily:'Outfit',
//                 fontWeight:'500',
//               }}
//             >
//               {city.name}
//             </Box>
//           </Box>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default CitySection;


import React from 'react';

import { Box, Typography, useMediaQuery } from '@mui/material';

import { useTheme } from '@mui/material/styles';
 
import hyderabadImg from '../../../assets/hyd.png';

import vizagImg from '../../../assets/vis.png';

import vijayawadaImg from '../../../assets/vij.png';
 
const cities = [

  { name: 'Hyderabad', image: hyderabadImg },

  { name: 'Visakhapatnam', image: vizagImg },

  { name: 'Vijayawada', image: vijayawadaImg },

];
 
const CitySection = () => {

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
 
  return (
<Box

      component="section"

      sx={{

        py: '40px',

        px: '20px',

        textAlign: 'center',

        bgcolor: '#ffffff',

        fontFamily: 'Outfit',

      }}
>
<Typography

        variant="h5"

        sx={{

          fontSize: '1.9rem',

          mb: '30px',

          fontWeight: 500,

        }}
>

        Your Perfect Place, Just a Click Away
</Typography>
<Box

        className="city-grid"

        sx={{

          display: 'grid',

          gridTemplateColumns: {

            xs: '1fr',             // 1 column for extra small screens

            sm: '1fr',             // 1 column for small screens

            md: 'repeat(3, 1fr)',  // 3 columns for medium screens and above

          },

          gap: '20px',

          width: '100%',

          maxWidth: '1440px',

          margin: '0 auto',

        }}
>

        {cities.map((city, idx) => (
<Box

            key={idx}

            className="city-card"

            sx={{

              width: '100%',

              height: '280px',

              borderRadius: '12px',

              overflow: 'hidden',

              position: 'relative',

              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',

              transition: 'transform 0.3s ease',

              '&:hover': {

                transform: 'translateY(-5px)',

              },

            }}
>
<Box

              component="img"

              src={city.image}

              alt={city.name}

              sx={{

                width: '100%',

                height: '280px',

                objectFit: 'cover',

                display: 'block',

              }}

            />
<Box

              className="city-name"

              sx={{

                backgroundColor: 'rgba(0, 0, 0, 0.6)',

                color: '#fff',

                fontSize: '1rem',

                position: 'absolute',

                bottom: 0,

                width: '100%',

                py: '30px',

                textAlign: 'center',

                fontFamily: 'Outfit',

                fontWeight: '500',

              }}
>

              {city.name}
</Box>
</Box>

        ))}
</Box>
</Box>

  );

};
 
export default CitySection;
 